import React from 'react';
import './Animation.css';

const Animation = () => {
  return (
    <div>
    <div className="heading">
        AUTHORIZED DISTRIBUTOR
    </div>
        <div class="logos">
      <div class="logos-slide">
        <img src="images/cl1.jpg" alt='' />
        <img src="images/cl2.jpg" alt='' />
        <img src="images/cl3.jpg" alt='' />
        <img src="images/cl4.jpg" alt='' />
        <img src="images/cl5.jpg" alt='' />
      </div>
    </div>
    </div>
  )
}

export default Animation